type Props = { status: string | null | undefined };

const TONES: Record<string, string> = {
  paid: 'bg-emerald-100 text-emerald-800',
  ready: 'bg-emerald-100 text-emerald-800',
  published: 'bg-emerald-100 text-emerald-800',
  draft: 'bg-slate-100 text-slate-700',
  archived: 'bg-slate-100 text-slate-500',
  uploading: 'bg-blue-100 text-blue-800',
  uploaded: 'bg-blue-100 text-blue-800',
  processing: 'bg-amber-100 text-amber-800',
  failed: 'bg-red-100 text-red-800',
  refunded: 'bg-red-100 text-red-800',
};

export default function StatusBadge({ status }: Props) {
  if (!status) return <span className="text-slate-400">—</span>;
  const tone = TONES[status] ?? 'bg-slate-100 text-slate-700';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${tone}`}>
      {status}
    </span>
  );
}
